import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import p1 from '../Pages/Newimages/p1.png'
import p2 from '../Pages/Newimages/p2.png'
import p3 from '../Pages/Newimages/p3.png'
import SvgIcons from './SvgIcons'


const Pricing = () => {
  return (
    <div>
            <Newnavbar />
            <div className="pricing_bg">
                <div className="pricing_bg_des container mx-auto ">
                <h1>Smart Payment Solutions for Your Business</h1>
                <div className="pricing_box max-w-5xl mx-auto">
                    <h3>Standard Plan</h3>
                    <p className='accept'>Accept all modes of payments at all customer touchpoints</p>
                    <div className=" grid md:grid-cols-3 grid-cols-1">
                        <div className="">
                            <div className="gold_bg">
                                <img src={p1} alt="" />
                                <div className='space-y-[8px]'>
                                    <h6 className='not'>IMPS / UPI Payouts</h6>
                                    <p>Instant. Secure. 24/7 IMPS Transfers</p>
                                </div>
                                <hr className=' border-t-3 border-[#F4EDD8] my-[16px]'/>

                                <ul className=''>
                                    <li><SvgIcons.Stars/> <p>₹1 to ₹1000 - <span>Flat Rs.10/-</span></p></li>
                                    <li><SvgIcons.Stars/> <p>₹1001 Onwards - <span>1%</span></p> </li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                        <div className="gold_bg white_bg">
                                <img src={p2} alt="" />
                                <div className='space-y-[8px]'>
                                    <h6>NEFT</h6>
                                    <p>Hassle-Free NEFT Transfers</p>
                                </div>

                                <hr className=' border-t-3 border-[#F4EDD8] my-[16px]'/>

                                <ul>
                                    <li><SvgIcons.Stars/> <p>₹1 to ₹1000 - <span>Flat Rs.5/-</span></p></li>
                                    <li><SvgIcons.Stars/> <p>₹1001 Onwards - <span>0.3%</span></p> </li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                        <div className="gold_bg">
                                <img src={p3} alt="" />
                                <div className='space-y-[8px]'>
                                <h6>UPI Collections</h6>
                                <p> Secure UPI Collections</p>
                                </div>

                                <hr className=' border-t-3 border-[#F4EDD8] my-[16px]'/>

                                <ul>
                                    <li><SvgIcons.Stars/> <p>₹1 to ₹1000 - <span>Flat Rs.20/-</span></p></li>
                                    <li><SvgIcons.Stars/> <p>₹1001 Onwards - <span>2%</span></p> </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="gst_all">
                        <h4>*GST 18% Applicable Extra*</h4>
                        <a href='/Contactus'>Try it Now</a>
                    </div>
                </div>

                </div>

           <div className="second_all  max-w-5xl mx-auto">
           <div className="pricing_box_second">
                    <h3> Special & Customize Plans</h3>
                    <p className='accept'>Smart & secure payment solution to boost your business growth.</p>

                    <div className="gst_all">
                        <h4>*GST 18% Applicable Extra*</h4>
                        <a href='/Contactus'>Contact Now</a>
                    </div>
           </div>
       
           </div>

            </div>
            <Newfooter />
      
    </div>
  )
}

export default Pricing
